const AsgUI = (function () {
    let $sessionClock;
    let timeCounterInterval;
    let timeSyncInterval;
    let timeDuration = false;
    let loginTimeCounterInterval;

    let inGameDepositButtonGradientTimer = null;
    const inGameDepositButton = $('.new-in-game-page .in-game-deposit-button');
    const inGameDepositButtonGradientClass = 'in-game-deposit-button--gradient';
    const inGameDepositButtonGradientTimeout = 1000 * 60; // 60 sec
    const LOW_DEPOSIT_BALANCE = 1000; // in coins (10 currency units)

    $(document).ready(function () {
        const $body = $('body');
        let isAustria;
        $sessionClock = $('.clock-container .session-time-bar');

        // asgReady event common handlers.
        $(document).on('asgReady', function () {
            setPromotionsVisitedSession();
            isAustria = AsgApp.isAustria();

            hideLoyaltySections();

            if (AsgApp.isSessionClockBarCountry()) {
                // init the session time bar.
                initTimeSyncTest($sessionClock, initLoginTimeCounter, false);
                initLoginTimeCounter($sessionClock, false);
            }

            if (isAustria && AsgApp.hasAustriaFlag()) {
                $body.addClass('austria-flag');
            }

            if (window.location.href.indexOf('#') === -1) {
                $(this).scrollTop(0);
            }

            setTimeout(function () { $('#version-num').show(); }, 3000);
            redirectVerificationEmail();
            removePreloadBrandStyle();
        });

        /**
         * add uk-hide-loyalty class to body if isHideLoyaltyPageFlag return true
         */
        const hideLoyaltySections = () => {
            $('body').toggleClass('uk-hide-loyalty', !!AsgFW.isHideLoyaltyPageFlag());
        };

        // startInGame event common handlers.
        $(document).on('startInGame', function () {
            // If the game changed start deposit button gradient from the beginning
            setInGameDepositButtonHandlers();
        });

        // loadGame event common handlers.
        $(document).on('loadGame', function () {
            $('.show-popup').fadeOut();
        });

        // loggedIn event common handlers.
        $(document).on('LoggedIn', function () {
            $body.addClass('LoggedIn').removeClass('LoggedOut');
            hideLoyaltySections();

            // render verification strip for relevant players
            AsgApp.showVerificationStrip();

            // Set UI features for Germany.
            setUIFeaturesDE();
        });

        // loggedOut event common handlers.
        $(document).on('LoggedOut', function () {
            $body.addClass('LoggedOut').removeClass('LoggedIn');

            Cookie.remove('shownPopUp');
            hideLoyaltySections();
            AsgApp.destroyVerificationStrip();

            // Set UI features for Germany.
            setUIFeaturesDE();
        });

        // justLoggedIn event common handlers.
        $(document).on('justLoggedIn', function () {
            // Force Promotions page refresh on user's login.
            forcePromotionsRefresh();
        });

        // justLoggedOut event common handlers.
        $(document).on('justLoggedOut', function () {
            // Force Promotions page refresh on user's logout.
            forcePromotionsRefresh();
        });

        // Remove Head navbar for mobile users while playing
        $(document).on('startInGame', function () {
            if (AsgFW.isMobilePamPlatform()) {
                $('nav.navbar, #site-header:not(.fixed), .in-game-header').addClass('hidden');
            }
        });

        // Return Head navbar for mobile users while playing
        $(document).on('endInGame', function () {
            if (AsgFW.isMobilePamPlatform()) {
                $('nav.navbar, #site-header:not(.fixed), .in-game-header').removeClass('hidden');
            }
        });

        // Mute jQuery migrate for dev env.
        if (Tools.isDebug()) {
            jQuery.migrateTrace = false;
        }

    });

    $(document).on('infoPopupOpened', function () {
        $('#popup-notification #aspnetForm .StandardPageLeftSectionContentOL a.ContentLinks').addClass('ready');
    });

    $(window).on('scroll', function () {
        const asgScrollToTop = $('#asg-scroll-to-top');
        const displayOnDesktop = asgScrollToTop.data('desktop');
        const y = window.scrollY;

        if (displayOnDesktop || (!displayOnDesktop && AsgFW.isMobilePamPlatform())) {
            if (y > 140) {
                asgScrollToTop.removeClass('not-visible');
                asgScrollToTop.addClass('visible');
            } else {
                asgScrollToTop.removeClass('visible');
                asgScrollToTop.addClass('not-visible');
            }
        }
    });

    $('#asg-scroll-to-top').on('click', function () {
        const scrollToTop = function () {
            // Let's set a constiable for the number of pixels we are from the top of the document.
            const c = document.documentElement.scrollTop || document.body.scrollTop;

            // If that number is greater than 0, we'll scroll back to 0, or the top of the document.
            if (c > 0) {
                window.requestAnimationFrame(scrollToTop);
                // ScrollTo takes an x and a y coordinate.
                // Increase the '10' value to get a smoother/slower scroll
                window.scrollTo(0, c - c / 10);
            }
        };
        scrollToTop();
    });

    /**
     * Changes Google events labels inner content, where there is a Pre/Post text value that
     * is meant to differentiate logged-in and logged-out events.
     */
    function toggleGAEvents() {
        const GaEventsToToggle = $('body .ga-ssostatus-toggle');
        if (GaEventsToToggle.length === 0) return;

        const toReplace = Player.isLoggedIn() ? 'Pre' : 'Post';
        const replacedBy = Player.isLoggedIn() ? 'Post' : 'Pre';

        GaEventsToToggle.each(function () {
            let value = $(this).attr('data-ga-label') || '';
            value = value.replace(toReplace, replacedBy);
            $(this).attr('data-ga-label', value);
            $(this).data('gaLabel', value);
        });
    }

    /**
     * This function checks every 4 seconds that the UI time counter is not out of sync.
     * The 'sync test' time frame must be bigger than the subject's time frame
     * @param {object} element Jquery object of the time element
     * @param {function} initFunc
     * @param {boolean} addition
     */
    function initTimeSyncTest(element, initFunc, addition = true) {
        let timestamp = Math.round(new Date().getTime() / 1000);
        if (timeSyncInterval) clearInterval(timeCounterInterval);
        if (loginTimeCounterInterval) clearInterval(loginTimeCounterInterval);
        timeSyncInterval = setInterval(function () {
            const curTime = Math.round(new Date().getTime() / 1000);
            if (curTime > timestamp + 2) { // Restart if counter is out of sync
                clearInterval(timeCounterInterval);
                clearInterval(loginTimeCounterInterval);
                initFunc(element, addition);
            }
            timestamp = Math.round(new Date().getTime() / 1000);
        }, 1000);
    }

    /**
     * This function start interval for display current login session time.
     * Update the Element with the current state.
     * @param {object} element Jquery object of the time element
     * @param {boolean} addition
     */
    function initLoginTimeCounter(element, addition = true) {
        timeDuration = AsgApp.getLoginTimeDuration();
        if (!timeDuration) return;
        timeDuration.then(function (time) {
            if (addition) element.html(`<span class="stopwatch-icon">&nbsp;</span><span class="hours">${formatTime(time.hours)}</span>:<span class="minutes">${formatTime(time.minutes)}</span>:<span class="seconds">${formatTime(time.seconds)}</span>`);
            clearInterval(loginTimeCounterInterval);
            loginTimeCounterInterval = setInterval(function () {
                // eslint-disable-next-line no-param-reassign
                time = updateTimeUI(time, element);
            }, 1000);
        });
    }

    function updateTimeUI(time, element) {
        element.find('.hours').text(formatTime(time.hours));
        element.find('.minutes').text(formatTime(time.minutes));
        element.find('.seconds').text(formatTime(time.seconds));

        // Clock logic
        if (time.seconds < 59) {
            // eslint-disable-next-line no-param-reassign
            time.seconds += 1;
        } else {
            // eslint-disable-next-line no-param-reassign
            time.seconds = 0;

            if (time.minutes < 59) {
                // eslint-disable-next-line no-param-reassign
                time.minutes += 1;
            } else {
                // eslint-disable-next-line no-param-reassign
                time.minutes = 0;

                // eslint-disable-next-line no-param-reassign
                time.hours += 1;
            }
        }

        return time;
    }

    function formatTime(time) {
        if (time.toString().length < 2) {
            return `0${time}`;
        }

        return time;
    }

    function showOverlay() {
        $('.cover-screen').show();
    }

    function hideOverlay() {
        $('.cover-screen').hide();
    }

    function showPopup(name) {
        if (!AsgFW.isMobilePamPlatform()) {
            showOverlay();
        }
        $('.show-popup').show();
        $('#popup-messages-container .popup-content').hide();
        $('#popup-messages-container').find(`[data-name="${name}"]`).show();
        $('.show-bonus-wager-popup').fadeIn();
    }

    // Cleans the privacy infopage from the extra td in it
    function cleanInfoPage() {
        const ele = $('.StandardPageLeftSectionContentTable tr:nth-of-type(3) .StandardPageLeftSectionContentTitle');
        if (ele.length > 0) {
            ele.parent('td').hide();
        }
    }

    /**
     * OLD NG Download server images dir configuration - left for the reference.
     * TODO: TOREMOVE after the full migration to Azure download server.
     * Adds an "images object" to each item of an array of game objects
     * @param {Array} gamesArr [{id:5},{id:12},...]
     * @returns Array
     */
    // function populatePreloadImages(gamesArr){
    //     const envPrefix = Tools.getEnvPrefix();
    //     envPrefix = envPrefix === 'dev.' ? 'qa.' : envPrefix === 'uat.' ? '' : envPrefix;
    //     return gamesArr.map(function (item) {return $.extend(item, {"images": {"default": "https://download." + envPrefix + "gamesrv1.com/NMWC/Resources/Game_Thumb/" + item.id + "/290x192_" + item.id + "_1x_ENG.jpg"}})});
    // }

    /**
     * Temporary solution - until all download server will be migrated to Azure
     * Adds an "images object" to each item of an array of game objects
     * @param {Array} gamesArr [{id:5},{id:12},...]
     * @returns Array
     */
    function populatePreloadImages(gamesArr) {
        return gamesArr.map(function (item) {
            return $.extend(item, {
                images: {
                    default: `${AsgApp.getGameThumbImagesUri()}${item.id}/290x192_${item.id}_1x_ENG.jpg`,
                },
            });
        });
    }

    function filterDemoButtons(component, gameParams) {
        // remove demo if the game has no demo
        if (gameParams.playModes.indexOf('Demo') === -1) {
            // eslint-disable-next-line no-param-reassign
            component = Tools.replaceAll(component, '[demopage]', 'no-demo');
            // eslint-disable-next-line no-param-reassign
            component = Tools.replaceAll(component, '[demopopup]', 'no-demo');
        } else {
            // always hide demo popup
            // eslint-disable-next-line no-param-reassign
            component = Tools.replaceAll(component, '[demopopup]', 'no-demo');
        }

        return component;
    }

    /**
     * checked if need filtered game (for winner ticker)
     * return TRUE by default else if player from UK and player not login and this game id (gid)
     * not exist on notPresentGames list (json)
     * json file managed on green backend
     * @param gid
     * @returns {boolean}
     */
    function isFilterNotPresentGames(gid) {
        let result = true;
        if (AsgApp.isUkCountry() && !Player.isLoggedIn() && Games.isPresentPageGames(gid)) {
            result = false;
        }
        return result;
    }

    // Function forces promotions index page to refresh.
    function forcePromotionsRefresh() {
        if (
            location.pathname.search(/\/promotions\/?$/) !== -1
            || location.pathname.search(/\/kampagner\/?$/) !== -1
        ) {
            location.reload();
        }
    }

    const isHomePage = function () {
        return window.location.pathname === '/';
    };

    const redirectVerificationEmail = function () {
        if (window.location.pathname === '/info/player-email-verification/') {
            setTimeout(function () {
                window.location.href = '/';
            }, 3000);
        }
    };

    // remove duplicate brand css (to show the CSS in the preload
    // and to move it then to the footer so it's rules will be stronger)
    const removePreloadBrandStyle = function () {
        $('.preload-css').remove();
    };

    // Remember if the user visited "Promotions" page on this session
    const setPromotionsVisitedSession = function () {
        if (window.location.pathname.indexOf('promotions') > -1) {
            sessionStorage.setItem('promotionsVisited', 'true');
        }

        const promosNumber = AsgApp.getAllPromotionsNumber();
        if (
            sessionStorage.getItem('promotionsVisited') === 'true'
            || parseInt(promosNumber, 10) === 0
            || promosNumber === ''
        ) {
            $('body').addClass('promotions-visited');
        }
    };

    /**
     * Handle on click event for submenus slide down.
     * Set onclick for submenu-parents behaviour (old side menu, new header, etc.)
     */
    const addSubmenuSlideDownOnClickHandler = () => {
        $('.sb-toggle-submenu').off('click') // Stop submenu toggle from closing Slidebars.
            .on('click', function (e) {
                const $submenu = $(this).parent().children('.sb-submenu');
                $(this).add($submenu).toggleClass('sb-submenu-active'); // Toggle active class.

                if ($submenu.hasClass('sb-submenu-active')) {
                    $submenu.slideDown(200);
                } else {
                    $submenu.slideUp(200);
                }
                e.stopPropagation();
            });
    };

    /**
     * initiate banners carousel react component
     * @return undefined
     * @param {bool} isAspireEngageBannerFlag
     * @param isTemplateTwo
     */
    const initBannersCarousel = (isAspireEngageBannerFlag) => {
        if (!document.getElementById('banners-carousel')) {
            return null;
        }

        const collapseBanners = setTimeout(() => collapseBannersFunc(), 40000);
        setAspireEngageEventListeners(isAspireEngageBannerFlag, collapseBanners);
    };

    const setAspireEngageEventListeners = (isAspireEngageBannerFlag, collapseBanners) => {
        const bannersReadyHandler = () => {
            const banners = getAsgBannersPrepared();
            if (isAspireEngageBannerFlag) {
                adjustBannersSize();
            }
            renderCarousel(banners, collapseBanners);
        };

        // handle the case when banners were ready before asgReady event
        if (getAsgBannersPrepared()) {
            bannersReadyHandler();
        }

        // show relevant loaders (animation or placeholder) on login state change
        document.addEventListener('justLoggedIn', showBannerLoader);
        document.addEventListener('justLoggedOut', showBannerLoader);

        // subscribe to banner updates
        document.addEventListener('AsgRenderCarousel', bannersReadyHandler);
        document.addEventListener('ASGSegmentedBannersReady', bannersReadyHandler);
        if (isAspireEngageBannerFlag) {
            document.addEventListener('AspireEngageBannersData', bannersReadyHandler);
        }
    };

    const getAsgBannersPrepared = () => (AsgFW.getAspireEngageBanners(
        1,
        AsgApp.getUnsegmentedBanners(),
        1,
        AsgFW.isPayNPlayAvailable(),
        AsgFW.getCurrency(),
    ));

    const renderCarousel = (bannersData, bannersCollapseTimerId = 0) => {
        const props = {
            element: document.getElementById('banners-carousel'),
            bannersData,
            globals: {
                Dictionary,
                AsgFW,
                AsgApp,
            },
        };

        if (Array.isArray(props.bannersData) && props.bannersData.length > 0) {
            cancelBannersSliderCollaps(bannersCollapseTimerId);

            AsgSharedComponents.services.ImgUtilService.preloadImg(
                props.bannersData[0].content.image,
                () => {
                    removeBannerLoader();
                    AsgSharedComponents.renderBannersCarousel(props);
                },
            );
        }
    };

    const initLeaderboardCarousel = (data) => {
        const props = {
            element: document.getElementById('asg-promotion-leaderboard'),
            data,
            globals: {
                Dictionary,
                AsgFW,
            },
        };
        AsgPromotionsComponents.renderLeaderboardCarousel(props);
    };

    const showBannerLoader = () => {
        const placeholderData = AsgApp.getPlaceholderBannerData();
        const bannerCarousel = document.getElementById('banners-carousel');
        const bannerLoader = document.querySelector('.asg-banners-loader');

        if (placeholderData.active) {
            const placeholderImage = `
                <img
                    src="${placeholderData.url}"
                    class="banners-wrapper__placeholder-img"
                    alt="Banner loading img"
                />
                <div class="carousel-content">
                    <div class="carousel-content__headlines">
                        <div class="carousel-content__title">${placeholderData.title || ''}</div>
                        <div class="carousel-content__subtitle">${placeholderData.subTitle || ''}</div>
                    </div>
                </div>
            `;

            if (bannerCarousel && window.AsgSharedComponents) {
                AsgSharedComponents.unmountComponent(bannerCarousel);
                bannerCarousel.innerHTML = placeholderImage;
            }
            return;
        }

        if (bannerCarousel) {
            bannerCarousel.classList.remove('banners-visible');
        }
        if (bannerLoader) {
            bannerLoader.classList.add('display-flex');
        }
    };

    const removeBannerLoader = () => {
        const bannerLoader = document.querySelector('.asg-banners-loader');
        if (bannerLoader) {
            bannerLoader.classList.remove('display-flex', 'banners-visible');
        }
        document.querySelector('#banners-carousel').classList.add('transition-opacity-in', 'banners-visible');
        document.querySelector('.banners-wrapper').classList.add('banners-visible');
    };

    const collapseBannersFunc = () => {
        document.querySelector('.banners-wrapper').classList.add('collapse-transition');
        document.querySelector('#banners-carousel').classList.add('collapse-transition');
    };

    const adjustBannersSize = () => {
        document.querySelector('.banners-wrapper').classList.add('aspire-engage');
        document.querySelector('#banners-carousel').classList.add('aspire-engage');
    };

    const cancelBannersSliderCollaps = (collapseBanners) => {
        clearTimeout(collapseBanners);
    };

    /**
     * New Side Bar menu common methods.
     * Use them in templates, where this feature is active.
     */
    const NSBMenu = {
        /**
         * Fill NSB Menu with post-login Player's data.
         */
        fillPostLoginData() {
            // Get Player's Data
            const Player = AsgFW.getSessionDetails();
            const Loyalty = AsgFW.getLoyaltyPoints();
            const Balance = AsgApp.getDisplayBalance();

            // check if obj exist (some time not have loyalty parameter)
            if (Loyalty) {
                // Add welcome message
                $('#nsb-menu #nsb-welcome').html(`<div id="nsb-crown" class="nsb-crown-lvl-${Loyalty.CurrentLevelNumber}"></div> ${Dictionary.translate('hello')}, &nbsp; <span>${Player.PlayerName}</span>`);

                // Add Loyalty data
                $('#nsb-loyalty-status').html(`
                    <div>${Loyalty.LoyaltyLevelName}</div>
                    <div id="nsb-loyalty-points" class="nsb-rating-lvl-${Loyalty.CurrentLevelNumber}"></div>
                    <div id="nsb-loyalty-progress"><div id="nsb-loyalty-progress-bar" class="nsb-progress-lvl-${Loyalty.CurrentLevelNumber}" style="width: ${Loyalty.ProgressPercentForNextLevel}%;">${Loyalty.ProgressPercentForNextLevel}%</div></div>
                `);
            }

            // Add balance data
            // Show separated real and bonus balances for UK and MGA+SPORT
            if (AsgApp.isUkCountry() || AsgApp.isSportActive()) {
                $('#nsb-balance').html(`
                    <div id="nsb-balance-real">
                        <div>${Dictionary.translate('balance')}</div>
                        <div class="nsb-balance-value">${Balance.DisplayRealBalance}</div>
                    </div>
                    <div id="nsb-casino-balance">
                        <div>${Dictionary.translate('casinoBonusBalance')}</div>
                        <div class="nsb-balance-value">${Balance.DisplayBonusBalance}</div>
                    </div>
                `);
            } else {
                // For MGA (-SPORT), DK and by default - show only common balance.
                $('#nsb-balance').html(`
                    <div id="nsb-balance-real">
                        <div>${Dictionary.translate('balance')}</div>
                        <div class="nsb-balance-value">${Balance.DisplayBalance}</div>
                    </div>
                `);
            }
        },

        /**
         * Add promotions number indicator.
         */
        addPromotionsNumber() {
            const allPromotionsNumber = AsgApp.getAllPromotionsNumber();
            if ($('#nsb-menu .item-promotions').length > 0) {
                $('#nsb-menu .item-promotions').each(function () {
                    $(this).append(`<div class="nsb-promotions-number">${allPromotionsNumber}</div>`);
                });
            }
        },

        /**
         * Add Google analytics event triggers
         */
        setGAEvents() {
            // Off non-relevant GA events
            $('#nsb-menu').off('click.NSBMenu');

            // Set new GA events.
            const loginState = AsgFW.isLoggedIn() ? 'post-login' : 'pre-login';
            const category = 'New Burger Menu';
            const action = `Burger Menu ${loginState} click`;

            // GA events for the Menu Brand Logo.
            $('#nsb-menu').on('click.NSBMenu', '#nsb-header-logo', function () {
                const label = 'Brand Logo';
                AsgApp.GAeventTracking(category, action, label);
            });

            // GA events for the Menu header buttons.
            $('#nsb-menu').on('click.NSBMenu', '.nsb-header-btn', function (e) {
                const label = e.currentTarget.dataset.action;
                AsgApp.GAeventTracking(category, action, label);
            });

            // GA events for Menu the search activation.
            $('#nsb-menu').on('click.NSBMenu', '#nsb-search-field', function () {
                const label = 'Search bar opened';
                AsgApp.GAeventTracking(category, action, label);
            });

            // GA events for Menu items.
            $('#nsb-menu').on('click.NSBMenu', 'ul li', function (e) {
                const label = e.currentTarget.classList[0].split('-')[1];
                AsgApp.GAeventTracking(category, action, label);
                e.stopPropagation();
            });

            // GA event for the click on the found game (search panel)
            $('#nsb-search-pane-results').on('click.NSBMenu', '.nsb-search-found-item', function (e) {
                const category = 'New Burger Menu_search';
                const action = `Game quick search - '${$('#nsb-search-pane-header-search-bar-input').val()}'`;
                const label = e.currentTarget.dataset.gamename;
                AsgApp.GAeventTracking(category, action, label);
            });
        },

        /**
         * Init search panel.
         */
        initSearchPane() {
            // Open NSB search pane menu by clicking on search field.
            $('#nsb-menu #nsb-search-field').on('click', function () {
                $('#nsb-menu #nsb-search-pane').addClass('nsb-search-shown');
                $('#nsb-search-pane-header-search-bar-input').trigger('focus');
            });

            // Add handlers to the controls:
            // Close search pane (arrow back)
            $('#nsb-search-pane-header-search-bar-back-arr').on('click', function () {
                $('#nsb-menu #nsb-search-pane').removeClass('nsb-search-shown');
            });

            // Clear search bar
            $('#nsb-search-pane-search-bar-clear').on('click', NSBMenu.clearSearchResults);

            // Search event handlers
            // Start search typing
            $('#nsb-search-pane-header-search-bar-input').on('keyup', function () {
                let searchVal = $(this).val();
                if (searchVal.length > 0) {
                    searchVal = AsgApp.stripHtml(searchVal);
                    NSBMenu.searchGames(searchVal);
                } else {
                    NSBMenu.clearSearchResults();
                }
            });

            // Game click - load game
            $('#nsb-search-pane-results').on('click.nsb-load-game', '.nsb-search-found-item', function (e) {
                AsgApp.loadGame(`${e.currentTarget.dataset.gameid}|M`);
                $(document).trigger('closeNSB');
            });

            // On login - refresh search results, as found games might not be operable.
            $(document).on('LoggedIn', function () {
                let searchVal = $('#nsb-search-pane-header-search-bar-input').val();
                if (searchVal.length > 0) {
                    searchVal = AsgApp.stripHtml(searchVal);
                    NSBMenu.searchGames(searchVal);
                }
            });
        },

        /**
         * Search games
         */
        searchGames(searchVal) {
            const games = Games.getFixedGamesList();
            const searchResults = [];
            const searchResultsByName = Games.filterGamesByName(searchVal, games);
            const searchResultsByProvider = Games.filterGamesByProvider(searchVal, games);
            searchResults.push(...searchResultsByName);
            searchResults.push(...searchResultsByProvider);
            // If typed at least 1 char - search games.
            if (!searchResults.length) {
                const searchResultsBySubProvider = Games.filterGamesBySubProvider(searchVal, games);
                searchResults.push(...searchResultsBySubProvider);
            }
            if (searchResults.length > 0) {
                NSBMenu.showSearchResults(searchResults, searchVal);
            } else {
                // Otherwise - show empty results.
                NSBMenu.showEmptySearchResult();
            }

            $('.nsb-search-buywin').click(function (e) {
                e.stopPropagation();
            });
        },

        /**
         * Clear search results.
         */
        clearSearchResults() {
            // Clear search input
            $('#nsb-search-pane-header-search-bar-input').val('');
            // Clear results list
            $('#nsb-search-pane-results-list').html('');
            // Clear search summary
            $('#nsb-search-pane-results-summary').html(Dictionary.translate('searchResShow'));
            // Focus search field
            $('#nsb-search-pane-header-search-bar-input').focus();
        },

        /**
         * Shows search results.
         * @param searchResults
         * @param searchVal
         */
        showSearchResults(searchResults, searchVal) {
            let searchResultsHTML = '';
            const searchResultsNumber = searchResults.length;

            // Prepare each found game item.
            searchResults.forEach(function (g) {
                // Mark search term to highlight it later with a color.
                const searchRegExp = new RegExp(searchVal, 'i');
                const searchTermPos = g.name.search(searchRegExp);
                let gameName = g.name;

                // if the match game is by name
                if (searchTermPos > -1) {
                    const gameNamePreTerm = g.name.substring(0, searchTermPos);
                    const gameNameTerm = g.name.substring(
                        searchTermPos,
                        (searchTermPos + searchVal.length),
                    );
                    const gameNamePostTerm = g.name.substring((searchTermPos + searchVal.length));
                    gameName = `${gameNamePreTerm}<span class="nsb-search-term">${gameNameTerm}</span>${gameNamePostTerm}`;
                }

                // get game image and placeHolder image
                const images = Games.getGameImageFromGameObject(g);

                // Add game item to the search result list HTML.
                searchResultsHTML += `<div class="nsb-search-found-item provider-${g.externalGameProvider.replace(/[ ]/g, '-')} sub-provider-${g.externalGameSubProvider.replace(/[ ]/g, '-')}" data-gameid="${g.id}" data-gamename="${g.name}">
                <picture>
                    <source type="image/webp" srcset="${images.gameImgWebp}"/>
                    <img
                        src="${images.gameImg}"
                        class="nsb-search-found-item-image"
                        onerror="this.src = null; this.parentNode.children[0].srcset = '${images.placeHolderImage}'"
                    />
                </picture>
                <div class="nsb-search-found-item-name">${gameName}</div>
                    <span class="buywin-icon" title="${Dictionary.translate('buyWinInfoText')}">
                        <a class="nsb-search-buywin" href="/promotions/buywin/" target="_blank"></a>
                    </span>
                </div>`;
            });

            // Show search results.
            $('#nsb-search-pane-results-list').html(searchResultsHTML);

            // Show search summary
            $('#nsb-search-pane-results-summary').html(`${searchResultsNumber} ${Dictionary.translate('resultsFor')} '<span class="nsb-search-term">${searchVal}</span>'`);
        },

        /**
         * Show empty search results.
         * @param searchVal
         */
        showEmptySearchResult() {
            // Clear results list
            $('#nsb-search-pane-results-list').html('');
            // Show 'nothing found' summary text
            $('#nsb-search-pane-results-summary')
                .html(Dictionary.translate('noResults'));
        },
    }; // End NSBMenu.

    /**
     * New Header UI global object.
     */
    const NewHeader = {
        // Selectors
        header: '.header',
        verticalsMenus: '.desktop-verticals, .mobile-verticals',
        mobileVerticals: '.mobile-verticals',
        desktopVerticals: '.desktop-verticals',
        verticalsItems: '.desktop-verticals-item, .mobile-verticals-item',
        mobileVerticalsItems: '.mobile-verticals-item',
        desktopVerticalsItems: '.desktop-verticals-item',
        desktopVerticalsPrimaryMenu: '.desktop-verticals__primary_menu',
        desktopVerticalsPrimaryMenuItems: '.desktop-verticals__primary_menu > .desktop-verticals-item',
        desktopVerticalsSecondary: '.desktop-verticals__secondary',
        desktopVerticalsSecondaryMenuItems: '.desktop-verticals__secondary_menu .desktop-verticals-item',
        verticalsSecondaryMenu: '.desktop-verticals__secondary_menu',
        verticalsSecondaryMenuToggle: '.desktop-verticals__more_toggle',
        headerRight: '.header__right',
        search: '.header__search',
        langSwitcher: '.header-language-switcher',
        langSwitcherBtn: '.header-language-switcher__btn',
        accountBtn: '.header-account__btn',
        langMenu: '.header-language-switcher__menu',
        accountMenu: '.header-account__menu',
        desktopSubHeaderMenuItems: '.subheader-desktop-menu > .menu-item > a',
        headerScrollingTransitionItem: '.header-transition__item',
        headerRegulationLogo: '.header-regulation-logo',
        regulationLogo: '.status-bar-logo-img',
        regulationLogoImg: '.header-regulation-logo__img',

        // Classes
        active: 'active',
        desktopVerticalsHidden: 'desktop-verticals_hidden',
        desktopVerticalsItemHidden: 'desktop-verticals-item_hidden',
        desktopVerticalsSecondaryVisible: 'desktop-verticals__secondary_visible',
        mobileVerticalsCenter: 'mobile-verticals__center',
        headerSearchHidden: 'header__search--hidden',
        headerLangSwitcherHidden: 'header-language-switcher_hidden',
        headerScrollingTransitionHidden: 'header-transition__item_hidden',

        // Observers
        desktopVerticalsMenuObserver: null,
        mobileVerticalsMenuObserver: null,

        init() {
            $(document).on('LoggedIn', NewHeader.renderStatusBarSubheader);
        },

        init3Y() {
            NewHeader.setEventHandlers3Y();
            NewHeader.showHiddenParts();
            NewHeader.handleTransitions();
        },

        setEventHandlers() {
            NewHeader.prepareVerticalsLinks();
            $(NewHeader.verticalsItems).on('click', NewHeader.addVerticalsOnClickHandler);
            $(NewHeader.verticalsSecondaryMenuToggle).on('click', NewHeader.showVerticalsSecondaryMenu);
            $(NewHeader.langSwitcherBtn).on('click', NewHeader.showLanguageMenu);
            $(NewHeader.accountBtn).on('click', NewHeader.showAccountMenu);
            $(document).on('LoggedIn', NewHeader.renderStatusBarSubheader);
            $(document).one('LoggedIn LoggedOut', NewHeader.setDesktopVerticalsMenuObserver);
            $(document).on('scroll', Tools.debounce(NewHeader.handleTransitions, 300));
            $(document).on('statusBarRendered', NewHeader.addRegulationLogo);
            AsgUI.addSubmenuSlideDownOnClickHandler();
        },

        setEventHandlers3Y() {
            $(AsgUI.NewHeader.langSwitcherBtn).on('mouseenter', AsgUI.NewHeader.showLanguageMenuByHover);
            $(AsgUI.NewHeader.accountBtn).on('mouseenter', AsgUI.NewHeader.showAccountMenuByHover);
            $(document).on('scroll', Tools.debounce(NewHeader.handleTransitions, 300));
            $(document).on('statusBarRendered', NewHeader.addRegulationLogo);
        },

        handleTransitions() {
            const scroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (scroll > 0) {
                $(NewHeader.headerScrollingTransitionItem)
                    .addClass(NewHeader.headerScrollingTransitionHidden);
            } else {
                $(NewHeader.headerScrollingTransitionItem)
                    .removeClass(NewHeader.headerScrollingTransitionHidden);
            }
        },

        addRegulationLogo(e) {
            const { showLogoUrl, showLogoLink } = e.detail;
            if (showLogoUrl) {
                $(NewHeader.headerRegulationLogo).addClass('active');
                $(NewHeader.regulationLogoImg).attr('src', showLogoUrl);
                if (showLogoLink) {
                    $(NewHeader.headerRegulationLogo).click(() => {
                        window.location = showLogoLink;
                    });
                }
            } else {
                $(NewHeader.headerRegulationLogo).removeClass('active');
            }
        },

        markCurrentVertical() {
            $(NewHeader.verticalsItems).removeClass(NewHeader.active);

            if (AsgApp.isVerticalPage()) {
                const $subHeaderMobile = $('.subheader-mobile');
                // Mobile subheader show only on verticals page
                $subHeaderMobile.removeClass('hidden');
            }

            const cv = AsgApp.getCurrentVertical();
            if (!cv) {
                return;
            }

            $(`${NewHeader.verticalsItems}`).filter(`[data-vertical-id=${cv.id}]`).addClass(NewHeader.active);

            // Move the selected mobile Vertical to the center of the menu view.
            if (AsgFW.isMobilePamPlatform()) {
                const avEl = $(`${NewHeader.mobileVerticalsItems}[data-vertical-id=${cv.id}]`)[0];
                if (avEl) {
                    $(NewHeader.mobileVerticals)[0]
                        .scrollLeft = avEl.offsetLeft - ((screen.width - avEl.offsetWidth) / 2);
                }
            }
        },

        showHiddenParts() {
            setTimeout(() => {
                // Show desktop verticals
                $(NewHeader.desktopVerticals).removeClass(NewHeader.desktopVerticalsHidden);
                // Show desktop language switcher
                $(NewHeader.langSwitcher).removeClass(NewHeader.headerLangSwitcherHidden);
            }, 10);
        },

        prepareVerticalsLinks() {
            $(NewHeader.verticalsItems).find('a').each((i, el) => {
                if (el.dataset.isSameLocation) {
                    // Disable links for the same location verticals.
                    $(el).on('click', (e) => {
                        e.preventDefault();
                    });
                }
            });
        },

        addVerticalsOnClickHandler(e) {
            const {
                verticalId, verticalName, verticalLocation, categoryId, subCategoryId,
            } = e.currentTarget.dataset;

            NewHeader.changeVerticalInUI({
                verticalId,
                verticalLocation,
                categoryId,
                subCategoryId,
                verticalName,
            });
        },

        changeVerticalInUI({
            verticalId,
            verticalLocation,
            categoryId,
            subCategoryId,
            verticalName,
        }) {
            const sso = AsgFW.isLoggedIn() ? 'Post' : 'Pre';
            const platform = AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop';

            // Save new Verticals / categories state
            AsgApp.setCurrentVerticalId(verticalId, verticalLocation);
            AsgApp.setCurrentCategorySet({
                categoryId,
                subCategoryId,
            }, verticalLocation);

            // Mark current vertical as active.
            NewHeader.markCurrentVertical();

            // Add GA events.
            AsgApp.GAeventTracking(
                `Verticals ${platform}`,
                `Click '${verticalName}' ${sso}`,
                verticalName,
            );

            /*
             * Render new vertical's content, if it's located right on the same page.
             * Otherwise the page will be changed with a link click.
             */
            if (verticalLocation === location.pathname) {
                // clear hash before vertical change
                location.hash = '';
                AppUI.renderVerticalContent();
            }
        },

        showVerticalsSecondaryMenu() {
            $(NewHeader.verticalsSecondaryMenu).addClass(NewHeader.active);
            setTimeout(() => {
                $(document).on('click', NewHeader.hideVerticalsSecondaryMenu);
            }, 0);
        },

        hideVerticalsSecondaryMenu() {
            if ($(NewHeader.verticalsSecondaryMenu).hasClass(NewHeader.active)) {
                $(NewHeader.verticalsSecondaryMenu).removeClass(NewHeader.active);
                $(document).off('click', NewHeader.hideVerticalsSecondaryMenu);
            }
        },

        handleSearchEnabled(event) {
            if (event.detail.isSearchEnabled) {
                $(NewHeader.search).removeClass(NewHeader.headerSearchHidden);
            } else {
                $(NewHeader.search).addClass(NewHeader.headerSearchHidden);
            }
        },

        showLanguageMenuByHover() {
            $(NewHeader.langMenu).addClass(NewHeader.active);
            setTimeout(() => {
                $(NewHeader.langMenu).on('mouseleave', NewHeader.hideLanguageMenuByHover);
            }, 0);
        },

        hideLanguageMenuByHover() {
            if ($(NewHeader.langMenu).hasClass(NewHeader.active)) {
                $(NewHeader.langMenu).removeClass(NewHeader.active);
                $(NewHeader.langMenu).off('mouseleave', NewHeader.hideLanguageMenuByHover);
            }
        },

        showAccountMenuByHover() {
            $(NewHeader.accountMenu).addClass(NewHeader.active);
            setTimeout(() => {
                $(NewHeader.accountMenu).on('mouseleave', NewHeader.hideAccountMenuByHover);
            }, 0);
        },

        hideAccountMenuByHover() {
            if ($(NewHeader.accountMenu).hasClass(NewHeader.active)) {
                $(NewHeader.accountMenu).removeClass(NewHeader.active);
                $(NewHeader.accountMenu).off('mouseleave', NewHeader.hideAccountMenuByHover);
            }
        },

        showLanguageMenu() {
            $(NewHeader.langMenu).addClass(NewHeader.active);
            setTimeout(() => {
                $(document).on('click', NewHeader.hideLanguageMenu);
            }, 0);
        },

        hideLanguageMenu() {
            if ($(NewHeader.langMenu).hasClass(NewHeader.active)) {
                $(NewHeader.langMenu).removeClass(NewHeader.active);
                $(document).off('click', NewHeader.hideLanguageMenu);
            }
        },

        showAccountMenu() {
            $(NewHeader.accountMenu).addClass(NewHeader.active);
            setTimeout(() => {
                $(document).on('click', NewHeader.hideAccountMenu);
            }, 0);
        },

        hideAccountMenu() {
            if ($(NewHeader.accountMenu).hasClass(NewHeader.active)) {
                $(NewHeader.accountMenu).removeClass(NewHeader.active);
                $(document).off('click', NewHeader.hideAccountMenu);
            }
        },

        markCurrentDesktopSubheaderLinks() {
            $(NewHeader.desktopSubHeaderMenuItems).each((i, el) => {
                if (UrlService.isSameHostPath(el.href) && el.dataset.action === 'navigateTo') {
                    el.classList.add(NewHeader.active);
                }
            });
        },

        renderStatusBarSubheader() {
            if (!AsgFW.isLoggedIn() || AsgFW.isMobilePamPlatform()) {
                return;
            }
            const statusBarPage = AsgApp.getStatusBarPage();
            AsgFW.initStatusBar(statusBarPage).then(res => {
                if (res) {
                    if (window.AsgStatusBar) {
                        window.AsgStatusBar.renderStatusBarSubheader(res);
                    }
                }
            });
        },

        setDesktopVerticalsMenuObserver() {
            // Disconnect the old observer, if existed.
            if (NewHeader.desktopVerticalsMenuObserver) {
                NewHeader.desktopVerticalsMenuObserver.disconnect();
            }

            // Compute new root margins.
            const headerRightWidth = $(NewHeader.headerRight).outerWidth();
            const moreWidth = $(NewHeader.verticalsSecondaryMenuToggle).outerWidth();
            if (typeof moreWidth === 'undefined') {
                return;
            }
            const totalRightMargin = headerRightWidth + moreWidth + 15;
            const desktopHeaderObserverOptions = {
                root: $(NewHeader.header)[0],
                rootMargin: `0px -${totalRightMargin}px 0px 0px`,
                threshold: 1.0,
            };

            // Set observer.
            NewHeader.desktopVerticalsMenuObserver = new IntersectionObserver(
                NewHeader.desktopVerticalsPrimaryNavigationHandler,
                desktopHeaderObserverOptions,
            );

            // Attach items to the observer.
            $(NewHeader.desktopVerticalsPrimaryMenuItems).each((i, el) => {
                NewHeader.desktopVerticalsMenuObserver.observe(el);
            });
        },

        desktopVerticalsPrimaryNavigationHandler(items) {
            items.reverse().forEach(i => {
                const el = i.target;
                if (!i.isIntersecting) {
                    NewHeader.addItemToSecondaryMenu(el);
                    $(el).addClass(NewHeader.desktopVerticalsItemHidden);
                } else {
                    NewHeader.removeItemFromSecondaryMenu(el);
                    $(el).removeClass(NewHeader.desktopVerticalsItemHidden);
                }
                NewHeader.showHideSecondaryMenu();
            });
        },

        containsItemInSecondaryMenu(menuItem) {
            return $(NewHeader.desktopVerticalsSecondaryMenuItems).is((i, el) => (
                el.dataset.verticalId === menuItem.dataset.verticalId
            ));
        },

        addItemToSecondaryMenu(menuItem) {
            if (!NewHeader.containsItemInSecondaryMenu(menuItem)) {
                $(menuItem).clone(true, true)
                    .prependTo(NewHeader.verticalsSecondaryMenu);
            }
        },

        removeItemFromSecondaryMenu(menuItem) {
            $(NewHeader.desktopVerticalsSecondaryMenuItems).filter((i, el) => (
                el.dataset.verticalId === menuItem.dataset.verticalId
            )).remove();
        },

        showHideSecondaryMenu() {
            const secondaryBlock = $(NewHeader.desktopVerticalsSecondary);
            const hiddenItems = $(`${NewHeader.desktopVerticalsPrimaryMenu} > .${NewHeader.desktopVerticalsItemHidden}`);
            if (hiddenItems.length > 0) {
                secondaryBlock.addClass(NewHeader.desktopVerticalsSecondaryVisible).css('left', `${hiddenItems[0].offsetLeft}px`);
            } else {
                secondaryBlock.removeClass(NewHeader.desktopVerticalsSecondaryVisible);
            }
        },

        setMobileVerticalsMenuObserver() {
            const mobileMenuItems = Array
                .from(document.querySelectorAll(NewHeader.mobileVerticalsItems));
            if (!mobileMenuItems.length) {
                return;
            }

            // Disconnect the old observer, if existed.
            if (NewHeader.mobileVerticalsMenuObserver) {
                NewHeader.mobileVerticalsMenuObserver.disconnect();
            }

            const mobileHeaderObserverOptions = {
                root: null,
                rootMargin: '0px -1px 0px 0px',
                threshold: 1.0,
            };

            // Set observer.
            NewHeader.mobileVerticalsMenuObserver = new IntersectionObserver(
                (items) => {
                    items.forEach(i => {
                        if (i.isIntersecting) {
                            document.querySelector(NewHeader.mobileVerticals)
                                .classList.add(NewHeader.mobileVerticalsCenter);
                        } else if (i.boundingClientRect.top > 0) {
                            // update class if intersection was done not by scroll up/down
                            document.querySelector(NewHeader.mobileVerticals)
                                .classList.remove(NewHeader.mobileVerticalsCenter);
                        }
                    });
                },
                mobileHeaderObserverOptions,
            );

            const lastMenuItem = mobileMenuItems.pop();
            NewHeader.mobileVerticalsMenuObserver.observe(lastMenuItem);
        },
    };
    // End New Header UI

    const popUpNotification = function (msg, callback) {
        const popUpNotificationInit = function () {
            const $popUp = $('#popup-notification');
            if ($popUp.length) {
                return $popUp;
            }

            // single creation of HTML element
            return $.get(`${AsgApp.getFrameworkUri()}includes/popup-notification.php`, function (html) {
                $(document.body).append(html);
            });
        };

        // Reset data set by previous call.
        const popUpNotificationPrepare = function () {
            const popUp = document.getElementById('popup-notification');
            const popUpTemplate = popUp.querySelector('#popup-content-template');
            const popUpContent = popUp.querySelector('.popup-content');

            popUpContent.innerHTML = popUpTemplate.content.querySelector('div').innerHTML;
        };

        const popUpNotificationApply = function () {
            const $popUp = $('#popup-notification');
            const $body = $('body');
            let currentScroll = 0;

            if (AsgFW.isMobilePamPlatform()) {
                currentScroll = $(window).scrollTop();
                $popUp.addClass('mobile');
            }
            $popUp.show();
            $body.addClass('popup-modal-open');
            $popUp.find('.popup-header').html(msg.head);
            if (msg.body) {
                $popUp.find('.popup-body').html(msg.body);
            }
            if (msg.btn) {
                $popUp.find('.btn').html(msg.btn);
            } else if (Object.hasOwn(msg, 'btn') && msg.btn === false) {
                $popUp.find('.btn').remove();
            }
            if (msg.action) {
                $popUp.find('.btn').attr('onclick', msg.action);
            }
            if (msg.customCss) {
                $popUp.find('.popup-content').css(msg.customCss);
            }
            if (msg.customBodyCss) {
                $popUp.find('.popup-body').css(msg.customBodyCss);
            }
            if (msg.customClass) {
                $popUp.addClass(msg.customClass);
            }
            if (msg.bottom) {
                $popUp.find('.popup-bottom').html(msg.bottom);
            }
            if (msg.img) {
                const imageElem = new Image();
                imageElem.src = msg.img;
                $popUp.find('.popup-body').html(imageElem);
            }
            if (msg.hideCrossButton) {
                $popUp.find('.close').css({ display: 'none' });
            }

            $popUp.find('.close, .btn').on('click', function () {
                $popUp.hide();
                $body.removeClass('popup-modal-open');
                if (msg.customClass) {
                    $popUp.removeClass(msg.customClass);
                }
                if (AsgFW.isMobilePamPlatform()) {
                    $(window).scrollTop(currentScroll);
                }
            });
        };

        $.when(popUpNotificationInit()).then(function () {
            popUpNotificationPrepare();
            popUpNotificationApply();
            $('#popup-notification .popup-body').scrollTop(0);
            $(document).trigger('infoPopupOpened');
            if (callback) {
                callback();
            }
        });
    };

    const popUpShow = function () {
        $('#popup-notification').show();
        $('body').addClass('popup-modal-open');
    };

    /**
     * open full screen by id element
     */
    $('.game-page-full-screen-open').on('click', () => {
        AsgApp.goInFullscreenById('in-game-container');
    });

    /**
     * close full screen
     */
    $('.game-page-full-screen-close').on('click', () => {
        AsgApp.goOutFullscreen();
    });

    /**
     * send lobby_open event if on game page or sport page
     */
    const fireTriggerIfIsGamePageOrSportPage = (page) => {
        if (
            AsgFW.isMobilePamPlatform()
            && (page === 'page.php' || page === 'sport-page.php' || page === 'template-home.php')
        ) {
            $(document).trigger('lobby_open');
        }
    };

    /**
     * Set Germany regulation UI features.
     * @return void
     */
    const setUIFeaturesDE = () => {
        // DE regulation
        if (AsgFW.isDEregulation()) {
            $('body').addClass('de-regulation');
        } else {
            $('body').removeClass('de-regulation');
        }

        // Germany Buy Win feature
        if (AsgApp.isGermanyBuyWinActive()) {
            $('body').addClass('germany-buy-win');
        } else {
            $('body').removeClass('germany-buy-win');
        }
    };

    $('.promotion-v2-terms-and-conditions-read-more, .promotion-v2-terms-and-conditions-read-less').on('click', (event) => {
        event.preventDefault();
        $('.promotion-v2-terms-and-conditions-content, .promotion-v2-terms-and-conditions-wrap').toggleClass('tab-close');
    });

    /**
     * render status bar.
     */
    const renderStatusBar = function () {
        if (AsgApp.getIsOneOfNativeApps()) {
            return;
        }
        const statusBarPage = AsgApp.getStatusBarPage();
        AsgFW.initStatusBar(statusBarPage).then(res => {
            if (res && res.showStatusBar) {
                $('body').addClass('status-bar-active');
                if (window.AsgStatusBar) {
                    window.AsgStatusBar.render(res);
                }
            } else {
                $('body').removeClass('status-bar-active');
            }
            const evt = new CustomEvent('statusBarRendered', {
                detail: res,
            });
            document.dispatchEvent(evt);
        });
    };

    /**
     * Add Handlers for Deposit button in header. Gradient class logic
     */
    const setInGameDepositButtonHandlers = () => {
        if (Player.isLoggedIn() && inGameDepositButton.length) {
            if (AsgApp.getDisplayBalance().Balance < LOW_DEPOSIT_BALANCE) {
                inGameDepositButton.addClass(inGameDepositButtonGradientClass);
            }
            inGameDepositButtonGradientTimer = setTimeout(
                onClickInGameDepositButton,
                inGameDepositButtonGradientTimeout,
            );
            inGameDepositButton.one('click', onClickInGameDepositButton);
        }
    };

    /**
     * Remove gradient and handlers for Deposit button, that were set up for gradient animation
     */
    const onClickInGameDepositButton = () => {
        inGameDepositButton.removeClass(inGameDepositButtonGradientClass);
        inGameDepositButton.off('click', onClickInGameDepositButton);
        clearTimeout(inGameDepositButtonGradientTimer);
    };

    const PromotionDatahubStateStrip = {
        interval: null,
        endDateTimeStamp: null,
        container: null,

        initCountdownStrip(dateTimeStamp) {
            PromotionDatahubStateStrip.endDateTimeStamp = dateTimeStamp;
            PromotionDatahubStateStrip.container = $('#promotion-countdown-strip');

            if (PromotionDatahubStateStrip.container.length) {
                $('body').addClass('has-promotion-countdown-strip');
                PromotionDatahubStateStrip.container.show();

                PromotionDatahubStateStrip.interval = setInterval(() => {
                    let days;
                    let hours;
                    let minutes;
                    let seconds;

                    // Find the difference between now and the count down date
                    const diff = PromotionDatahubStateStrip.endDateTime()
                        - PromotionDatahubStateStrip.nowDateTime();

                    if (diff > 0) {
                        // Time calculations for days, hours, minutes and seconds
                        [days, hours, minutes, seconds] = [
                            Math.floor(diff / (1000 * 60 * 60 * 24)),
                            Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                            Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
                            Math.floor((diff % (1000 * 60)) / 1000),
                        ].map(PromotionDatahubStateStrip.formatStr);
                    } else {
                        clearInterval(PromotionDatahubStateStrip.interval);
                        [days, hours, minutes, seconds] = Array(4).fill('00');
                    }

                    PromotionDatahubStateStrip.setTimeToDomElement(
                        days,
                        hours,
                        minutes,
                        seconds,
                    );
                }, 1000);
            }
        },

        initStaticStrip() {
            PromotionDatahubStateStrip.container = $('#promotion-strip');
            if (PromotionDatahubStateStrip.container.length) {
                $('body').addClass('has-promotion-strip');
            }
        },

        formatStr: (num) => String(num).padStart(2, '0'),

        endDateTime: () => new Date(PromotionDatahubStateStrip.endDateTimeStamp),

        nowDateTime: () => new Date(),

        setTimeToDomElement(days, hours, minutes, seconds) {
            [
                [PromotionDatahubStateStrip.container.find('.countdown-strip-days'), days],
                [PromotionDatahubStateStrip.container.find('.countdown-strip-hours'), hours],
                [PromotionDatahubStateStrip.container.find('.countdown-strip-minutes'), minutes],
                [PromotionDatahubStateStrip.container.find('.countdown-strip-seconds'), seconds],
            ].forEach(value => {
                const [element, clockStr] = value;
                if (element && element.text() !== clockStr) {
                    element.text(clockStr);
                }
            });
        },
    };

    const Accordion = {
        MODES: {
            SINGLE: 'single',
            MULTI: 'multi',
        },

        collapseElement(element) {
            const height = element.scrollHeight;
            element.style.height = height + 'px';
            requestAnimationFrame(() => {
                element.style.transition = 'height 300ms ease';
                element.style.height = '0px';
            });
            element.addEventListener('transitionend', function handler() {
                element.classList.remove('in');
                element.style.removeProperty('height');
                element.style.removeProperty('transition');
                element.removeEventListener('transitionend', handler);
            });
        },

        expandElement(element) {
            element.classList.add('in');
            element.style.height = '0px';
            requestAnimationFrame(() => {
                const height = element.scrollHeight;
                element.style.transition = 'height 300ms ease';
                element.style.height = height + 'px';
            });
            element.addEventListener('transitionend', function handler() {
                element.style.removeProperty('height');
                element.style.removeProperty('transition');
                element.removeEventListener('transitionend', handler);
            });
        },

        isSingleMode(group) {
            return group?.getAttribute('data-accordion-mode') === Accordion.MODES.SINGLE;
        },

        toggleCollapse(trigger) {
            const targetSelector = trigger.getAttribute('data-target');
            const target = document.querySelector(targetSelector);
            if (!target) return;

            const isOpen = target.classList.contains('in');
            const parentWithMode = trigger.closest('[data-accordion-mode]');
            const accordionMode = parentWithMode?.getAttribute('data-accordion-mode');
            if (accordionMode === Accordion.MODES.SINGLE && !isOpen) {
                const sharedContainer = parentWithMode.closest('.quick-links-container');
                const openPanels = sharedContainer?.querySelectorAll('.collapse.in') ?? [];
                openPanels.forEach(panel => {
                    if (panel !== target) {
                        Accordion.collapseElement(panel);
                        document.querySelectorAll(`[data-target="#${panel.id}"]`).forEach(el => {
                            el.setAttribute('aria-expanded', 'false');
                            el.classList.add('collapsed');
                        });
                    }
                });
            }

            if (isOpen) {
                Accordion.collapseElement(target);
                trigger.setAttribute('aria-expanded', 'false');
            } else {
                Accordion.expandElement(target);
                trigger.setAttribute('aria-expanded', 'true');
            }
            document.querySelectorAll(`[data-target="${targetSelector}"]`).forEach(element => {
                element.classList.toggle('collapsed', isOpen);
            });
        },

        initTriggers() {
            document.querySelectorAll('.collapse.in').forEach(el => {
                const height = el.offsetHeight;
                if (height === 0) {
                    el.classList.remove('in');
                    el.style.removeProperty('height');
                    el.style.removeProperty('transition');
                }
            });
            const collapseTriggers = document.querySelectorAll('.js-collapse-trigger');
            collapseTriggers.forEach(trigger => {
                trigger.addEventListener('click', function () {
                    Accordion.toggleCollapse(this);
                });
            });
        }
    };

    document.addEventListener('DOMContentLoaded', Accordion.initTriggers);

    // Public interface.
    return {
        showOverlay,
        filterDemoButtons,
        hideOverlay,
        showPopup,
        cleanInfoPage,
        populatePreloadImages,
        isFilterNotPresentGames,
        isHomePage,
        toggleGAEvents,
        NSBMenu,
        NewHeader,
        PromotionDatahubStateStrip,
        popUpNotification,
        popUpShow,
        fireTriggerIfIsGamePageOrSportPage,
        addSubmenuSlideDownOnClickHandler,
        renderStatusBar,
        initBannersCarousel,
        initLeaderboardCarousel,
        Accordion,
    };
})();

/*** EXPORTS FROM exports-loader ***/
export {
  AsgUI
};
